export default __webpack_public_path__ + "static/media/0_Still.a137db76.jpg";